{
    "coordinates": [
        33.59616532529229,
        -98.62554352709518
    ],
    "tooltip": "Archer City",
    "title": "Archer City Formation",
    "country": "United States",
    "period": "Permian",
    "alt": "TODO"
}
